import React, { Fragment } from 'react'
import { string, func, bool, oneOfType } from 'prop-types'
import Icon from '../icon/icon'
import Label from './label'

const UserInfoSummary = ({
  userName,
  email,
  branch,
  location,
  country,
  phone,
  companyWebsite,
  onEditHandler
}) => {
  return (
    <Fragment>
      <Label text={window.NFT.I18n.single_info_request.contact_information} />
      <div className='nft-user-info__container'>
        <button className='nft-user-info__edit' type='button' onClick={onEditHandler}>
          <Icon svg='edit' withoutFill /> {window.NFT.I18n.single_info_request.edit}
        </button>
        <p className='nft-user-info__item'>
          <span className='nft-user-info__item--highlight'>{userName}</span>
          { branch && <span> - {branch}</span> }
        </p>
        <p className='nft-user-info__item'>{email}</p>
        <p className='nft-user-info__item'>{`${location}, ${country}`}</p>
        { companyWebsite && <p className='nft-user-info__item'>{companyWebsite}</p> }
        { phone && <p className='nft-user-info__item'>{phone}</p> }
      </div>
    </Fragment>
  )
}

UserInfoSummary.propTypes = {
  userName: string.isRequired,
  email: string.isRequired,
  branch: string,
  location: string.isRequired,
  country: string.isRequired,
  phone: oneOfType([string, bool]),
  onEditHandler: func.isRequired
}

export default UserInfoSummary